import { TAG_CODES } from "../../tag.config"

const GOM_POINT_SENSITIVE_TARGET = {
    type: 'triangle',
    tagCode: TAG_CODES.DEFAULT,
    withText: true,
    defaultText: 'Sensitive target',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 180,
    colorCodeId: 'people',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
}

export default GOM_POINT_SENSITIVE_TARGET